import { DbMongoBaseInfos } from "./db-mongo-base-infos";

export class Clip extends DbMongoBaseInfos {
  frameIn: number | null = 0; // may be should be null
  frameOut: number | null = null;
  date: Date | null = null;
  userName: string | null = null;
  comment: string | null = null;
  remoteIp: string | null = null;
  importedOnAssetId: number | null = null;
  timecodeIn: string | null = null;
  timecodeInFile: string | null = null;
  timecodeOut: string | null = null;
  timecodeOutFile: string | null = null;

  constructor(init?: Partial<Clip>) {
    super();
    Object.assign(this, init);
  }
}
